export const MARKETPLACE_CATEGORIES = [
  'Informatique et numérique',
  'Mode et beauté',
  'Électronique et électroménagers',
  'Alimentation',
  'Beauté et hygiène',
  'Services professionnels',
  'Construction et immobilier',
  'Agriculture et élevage',
  'Industrie et transformation',
  'Hôtellerie et restauration',
  'Transport et logistique',
  'Énergie et environnement',
  'Mode et textile',
  'Maison et décoration',
  'Artisanat et culture',
  'Équipements professionnels',
  'Fournitures de bureau',
] as const;

export type MarketplaceCategory = (typeof MARKETPLACE_CATEGORIES)[number];

export type MarketplaceSort = 'recent' | 'price-asc' | 'price-desc' | 'rating';

/** Limites CDC ISBD MarketPlace */
export const MAX_SHOPS_PER_USER = 1;
export const MAX_PRODUCTS_PER_SHOP = 10;
export const MAX_PRODUCT_IMAGES = 6;
/** Boutique premium (vedettes incluses automatiquement). */
export const MAX_PREMIUM_PRODUCTS = 5;

export interface MarketplaceTestimonial {
  author: string;
  rating?: number;
  text: string;
}

export interface MarketplaceShop {
  id: string;
  user_id: string;
  project_id: string | null;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}

export interface MarketplaceProduct {
  id: string;
  owner_id: string | null;
  shop_id: string | null;
  project_id: string | null;
  name: string;
  description: string;
  category: string;
  price: number;
  old_price: number | null;
  currency: string;
  photo_urls: string[];
  video_url: string | null;
  seller_name: string;
  seller_logo: string | null;
  seller_email: string | null;
  seller_phone: string | null;
  is_premium: boolean;
  /** Produit vedette → ajouté auto à la boutique premium. */
  is_featured: boolean;
  is_published: boolean;
  rating: number;
  testimonials: MarketplaceTestimonial[];
  created_at: string;
  updated_at: string;
}

export const MARKETPLACE_PLACEHOLDER_PHOTO = '/images/africa-market-colors.jpg';
